<template>
  <div>
    <vs-popup :title="$t('CreateNewCountry')" :active.sync="showModal">
      <form class="w-full">
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="model.name"
            :label="$t('NameCountry')"
            name="NameCountry"
            v-validate="{  required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("NameCountry")
          }}</span>
        </div>

        <div class="w-full mt-3">
          <vs-input
            class="inputx mb-3"
            v-model="model.priority"
            :label="$t('Priority')"
            name="priority"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Priority')">{{
            errors.first("Priority")
          }}</span>
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          :disabled="!model.priority || !model.name"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    Name: {
      required: "لطفا نام کشور را وارد نمایید.",
    },
    Priority: {
      required: "لطفا اولویت را وارد نمایید.",
    },

  }
};
Validator.localize("fa", dict);
export default {
  name: "",
  props: {
    show: { default: false }
  },
  components: {},
  data() {
    return {
      model: {},
      disabled: true
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      createCountry: "country/create"
    }),
    submitForm() {
      this.$validator.validateAll().then(r => {
        if (r) {
          // if (this.model.name != "") {
          this.createCountry(this.model).then(() => {
            this.disabled = false;
            this.$emit("finish");
            this.model = {};
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطا در ثبت مقادیر وارده شده",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    }
  },
  watch: {
    model() {
      if (
        this.model.name &&
        this.model.priority
      ) {
        this.disabled = false;
      }
    }
  }
};
</script>
